<template>
  <el-menu class="navbar" mode="horizontal" :style="{height}">
    <div class="lines"></div>
    <div class="navbar-left" :style="{height}">
      <div class="logo-container row no-gutters align-items-center">
        <div class="col-auto">
          <img src="../../../assets/logo-base.png" alt="" :style="logoStyle">
        </div>
        <div class="col project-title">
          <div class="line1" :style="titleLine1Style">山水互联</div>
          <div class="line2" :style="titleLine2Style">ShanShui Internet</div>
        </div>
      </div>
    </div>
    <div class="right-menu row no-gutters" :style="rightMenuStyle">
      <div class="avatar-wrapper col-auto">
        <img class="user-avatar" :src="avatar" :style="avatarStyle"/>
      </div>
      <div class="col-auto nickname" v-if="nickname" :style="nicknameStyle">{{ nickname }}</div>
      <div class="loginOut col-auto" @click="logout" :style="logoutStyle">
        <i class="el-icon-switch-button"></i>
      </div>
    </div>
  </el-menu>
</template>

<script>
import {mapGetters} from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger';
import Screenfull from '@/components/Screenfull';
import LangSelect from '@/components/LangSelect';
import ThemePicker from '@/components/ThemePicker';
import Resize from '../mixin/resize';

import DefaultAvatar from '../../../assets/logo_images/icon-noface.jpg';

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    LangSelect,
    ThemePicker
  },
  data() {
    return {
      fromEnterUser: null
    }
  },
  mixins: [Resize],
  computed: {
    ...mapGetters(['sidebar', 'user']),
    height() {
      return `${80 * this.scale}px`;
    },
    logoStyle() {
      return {
        height: `${35 * this.scale}px`,
      };
    },
    titleLine1Style() {
      return {
        fontSize: `${18 * this.scale}px`,
        marginTop: `${4 * this.scale}px`,
      }
    },
    titleLine2Style() {
      return {
        fontSize: `${12 * this.scale}px`,
        marginTop: `${4 * this.scale}px`,
      }
    },
    rightMenuStyle() {
      return {
        height: this.height,
        paddingRight: `${24 * this.scale}px`,
      }
    },
    nickname() {
      return (this.fromEnterUser ? this.fromEnterUser.nickname : this.user.nickname) || '';
    },
    nicknameStyle() {
      return {
        fontSize: `${18 * this.scale}px`,
        padding: `0 ${12 * this.scale}px`,
      };
    },
    logoutStyle() {
      return {
        fontSize: `${24 * this.scale}px`,
      };
    },
    avatar() {
      return (this.fromEnterUser ? this.fromEnterUser.face : this.user.face) || DefaultAvatar;
    },
    avatarStyle() {
      return {
        width: `${48 * this.scale}px`,
        height: `${48 * this.scale}px`,
      };
    }
  },
  mounted() {
    // 刷新浏览器，企业跳转到站点应该获取站点的用户信息而非cookie里面的seller_user
    if (sessionStorage.getItem('from_enter_seller_user')) {
      this.fromEnterUser = JSON.parse(sessionStorage.getItem('from_enter_seller_user'));
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar');
    },
    logout() {
      this.$confirm('确定退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logoutAction').then(() => {
          window.location.href = '/login';
        });
      });
    }
  }
};
</script>

<style lang="scss">
@import "../../../plugins/variables";

.navbar {
  //height: 60px;
  height: 80px;
  border-radius: 0 !important;
  //background-color: lighten(#001529, 5%);
  //background-color: #262F3E !important;
  background-color: #fff;
  //border-bottom: 0 !important;
  //box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  //border-bottom: 1px solid #B8C2CC !important;
  z-index: 99;

  .lines {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;

    &::before {
      content: ' ';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 90%;
      transform: translate(-85%, -50%) rotate(24deg);
      background: rgba(255, 255, 255, 0.03);
    }
  }

  .navbar-left {
    float: left;
    display: flex;
    height: 79px;
    align-items: center;
    padding-left: 15px;

    .logo-container {
      height: 100%;

      img {
        height: 35px;
      }

      .project-title {
        //color: #fff;
        color: #333;
        padding-left: 8px;

        .line1 {
          font-weight: bold;
          font-size: 18px;
          line-height: 1;
          margin-top: 4px;
        }

        .line2 {
          margin-top: 4px;
          font-size: 12px;
          transform-origin: top left;
          //transform: scale(0.9);
        }
      }
    }
  }

  .hamburger-container {
    padding: 0 10px;
  }

  .breadcrumb-container {
    float: left;

    ::v-deep {
      .el-breadcrumb__separator,
      .el-breadcrumb__item .el-breadcrumb__inner a {
        font-size: 16px;
        //color: #fff !important;
        color: #333 !important;
      }

      .el-breadcrumb__item .el-breadcrumb__inner .no-redirect {
        font-size: 16px;
        //color: #fff !important;
        color: #333 !important;
      }
    }
  }

  .right-menu {
    display: flex;
    align-items: center;
    float: right;
    height: 79px;
    padding-right: 16px;

    ::v-deep svg {
      //fill: #fff !important;
      fill: #333 !important;
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 15px;
    }

    .avatar-container {
      height: 60px;
      margin-right: 30px;
    }

    .avatar-wrapper {
      cursor: pointer;
      position: relative;
      font-size: 9px;
      //color: #fff;
      color: #333;

      .user-avatar {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-right: 7.5px;
        object-fit: cover;
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 24px;
      }

      ::v-deep .el-icon-caret-bottom {
        color: $nav_text_active !important;
      }
    }

    .nickname {
      font-size: 18px;
      line-height: 1;
      padding: 0 12px;
    }

    .loginOut {
      text-align: center;
      margin-bottom: 3px;
      //color: #fff;
      color: #333;
      font-size: 24px;
      cursor: pointer;
    }

    .loginOut img {
      height: 16px;
      width: 16px;
      cursor: pointer;
    }
  }
}
</style>
